export default "__VITE_ASSET__CeU$GUJL__"